<div class="rider-header">
  <span class="rider-header-label">Rider Details</span>
</div>
<div class="booking-details-wrapper">
    <div class="booking-header" [ngClass]="{'collapsed-view': !isDetailVisible}">
      <div *ngIf="showBookingId" class="booking-id-column">
        <label class="detail-label">Booking Id</label>
        <div class="detail-info">{{booking.bookingId}}</div>
      </div>
      <div class="detail-wrapper">
        <div class="date-column">
          <div class="detail">
            <label class="detail-label"><span class="detail-label-text">Date</span></label>
            <div class="detail-info">{{booking.startTime | dateTimeConverter}}</div>
          </div>
          <div class="detail" *ngIf="booking.cabCount">
            <label class="detail-label"><span class="detail-label-text"># of cabs</span></label>
            <div class="detail-info">{{booking.cabCount}}</div>
          </div>
        </div>
        <ng-container *ngFor="let field of config">
          <div class="detail-column detail" *ngIf="booking[field.elementKey]">
            <label class="detail-label"><span class="detail-label-text">{{field.config.displayName}}</span></label>
            <div class="detail-info" *ngIf="field.elementKey != 'vendor'">
              {{booking[field.elementKey] | booleanConverter}}
            </div>
            <div class="detail-info" *ngIf="field.elementKey == 'vendor'">
              {{booking[field.elementKey].vendorName || booking[field.elementKey]}}
            </div>
          </div>
        </ng-container>
      </div>
      <div class="controls">
        <app-button
          (clickCallback)="toggleView()"
          [prefixIconSrc]="isDetailVisible ? 'assets/ic-navigation-chevron-up-24.svg' : 'assets/ic-navigation-chevron-down-24.svg'"
          type="icon"
        ></app-button>
      </div>
    </div>
    <div class="stop-container">
      <span *ngIf="isMultiDayBooking"class="multiDay1-label">Day-1</span>
      <div class="stop-table" *ngIf="isDetailVisible">
        <div class="stop-table-header">
          <div class="header time-column">Time</div>
          <div class="header address-column">Stops</div>
          <div class="header pickup-column">
            <!-- <img class="mr-10" src="assets/pickup.svg"/> -->
            Pick Up
          </div>
          <div class="header drop-column">
            <!-- <img class="mr-10" src="assets/drop-point.svg"/> -->
            Drop Off
          </div>
        </div>
        <div class="stop-table-row" *ngFor="let stop of booking.stops">
          <div class="table-cell time-column" *ngIf="miscelleneousConfig['12hrTimeFormat'] === 'true'">{{stop.time | timeFormatter}}</div>
          <div class="table-cell time-column" *ngIf="miscelleneousConfig['12hrTimeFormat'] === 'false'">{{getTimein24HourFormat(stop.time)}}</div>
          <div class="table-cell address-column">{{stop.address}}</div>
          <div class="table-cell pickup-column">{{stop.riders | riderName:'':'PickUp'}}</div>
          <div class="table-cell drop-column">{{stop.riders | riderName:'':'Drop'}}</div>
        </div>
      </div>
    </div>
</div>

<!-- -----------------multiday information  -->
<div *ngIf="isMultiDayBooking">
  <div  class="fs-20 mb-16 font-weight-400">MultiDay - Multistops</div>
  <div class="mb-16 padding-bottom-16 displayFlexColumn" *ngFor="let day of booking.multiDays; let dayindex=index" [ngStyle]="dayindex==booking.multiDays.length-1 ? {'border-bottom': 'none'}: {'border-bottom': '1px solid #e0e0e0'}">
    <div class="fs-20 font-weight-700 mb-8">Day-{{day.day}}</div>
    <div class="displayFlexRow">
      <div class="mid-stops mr-16 displayFlexRow" *ngFor="let stop of day.stops">
        <div class="mr-12"><img src="assets/stop-marker-small.svg" alt=""></div>
        <div class="displayFlexColumn">
           <div class="mb-12 fs-15 address-section" >{{getAddress(stop.address)}}</div>
           <div class="fs-12 geoaraea-label geoarea-section" >{{stop.geoArea}}</div>
        </div>
    </div>
    </div>
  </div>
</div>

